import { useEffect } from 'react';

// Auto-scroll horizontal de la frise quand on drague/redimensionne une affectation près du bord visible :
// sans ça, impossible d'étendre une affectation au-delà des jours déjà affichés à l'écran.
export function useTimelineAutoScroll({
  timelineBodyScrollRef,
  timelineDrag,
  timelineLastMouseX,
  timelineResize,
}) {
  useEffect(() => {
    if (!timelineDrag && !timelineResize) return;
    const EDGE = 70,
      MAX_SPEED = 24;
    const iv = setInterval(() => {
      const el = timelineBodyScrollRef.current,
        x = timelineLastMouseX.current;
      if (!el || x == null) return;
      const rect = el.getBoundingClientRect();
      let speed = 0;
      if (x < rect.left + EDGE) speed = -MAX_SPEED * (1 - Math.max(0, x - rect.left) / EDGE);
      else if (x > rect.right - EDGE) speed = MAX_SPEED * (1 - Math.max(0, rect.right - x) / EDGE);
      if (speed) el.scrollLeft += speed;
    }, 16);
    return () => clearInterval(iv);
  }, [!!timelineDrag, !!timelineResize]);
}
